import React from 'react';

interface BioTrackerLogoProps {
  onClick?: () => void;
}

export default function BioTrackerLogo({ onClick }: BioTrackerLogoProps) {
  const imagePriorityProps = { fetchpriority: 'low' } as React.ImgHTMLAttributes<HTMLImageElement>;

  return (
    <div className="biotracker-logo" onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      <img src="/images/Biotracker.logo.svg" alt="BioFilm" width="100%" decoding="async" {...imagePriorityProps} />
    </div>
  )
}